// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"5de30964","939":"3aaf3674"}[chunkId] + ".chunk.js";
};